import Axios, { AxiosInstance } from 'axios';
import { MeterDetails } from './MeterDetails';
import { ForecastApiResult } from './ForecastApiResult';

export default class ForecastApi {
  private client: AxiosInstance;

  constructor() {
    this.client = Axios.create({
      baseURL: import.meta.env.VITE_API_FORECAST_URL,
    });
  }

  getForecastForToday(meterDetails: MeterDetails): Promise<ForecastApiResult> {
    const orientationInDegrees: number = meterDetails.orientation_in_degrees;
    const azimuth: number = ((orientationInDegrees + 180) % 360) - 180;

    const params: object = {
      apikey: import.meta.env.VITE_API_FORECAST_KEY,
      latitude: meterDetails.plant.address.latitude,
      longitude: meterDetails.plant.address.longitude,
      tilt: meterDetails.angle_in_degrees,
      azimuth: azimuth,
      timezone: meterDetails.plant.time_zone,
      hourly: 'global_tilted_irradiance,weather_code',
      forecast_days: 2,
    };

    return this.client.get('/forecast', {
      params: params,
    });
  }
}
